const formattedTermEnd = (termEndDate) => {
  const parts = termEndDate.split('/');
  return {
    termYear: Number(parts[2]),
    termMonth: Number(parts[0]),
    termDay: Number(parts[1])
  };
};

export const evaluateExpiration = (expirationDate, evalDate) => {
  const parts = expirationDate.split('-');
  const itemYear = Number(parts[0]);
  const itemMonth = Number(parts[1]);
  const itemDay = Number(parts[2]);

  const { termYear, termMonth, termDay } = formattedTermEnd(evalDate);

  if (itemYear !== termYear) return itemYear > termYear;
  if (itemMonth !== termMonth) return itemMonth >= termMonth;
  return itemDay >= termDay;
};

export default function getClaimedPromotionalItemsInTerm(promotions, termEndDate) {
  if (!promotions || promotions.length === 0 || !termEndDate) return null;

  const claimedItem = promotions.filter(
    (item) => evaluateExpiration(item.expirationDate, termEndDate)
  );

  if (!claimedItem || claimedItem.length !== 1) return null;
  return claimedItem[0] ?? null;
}
